module.exports = __webpack_public_path__ + "static/media/agrawebp.0948b674.webp";